<template>
  <div id="addDeivce" v-loading="isLoging">
    <el-dialog
      title="编辑设备"
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="$emit('close')"
    >
      <div id="shared" style="margin-top: 1rem; margin-right: 100px">
        <el-form
          ref="addDeivce"
          :rules="isView ? [] : rules"
          :model="deviceParam"
          label-width="140px"
        >
          <el-form-item label="设备名称" prop="shareName">
            <el-input
              v-model="deviceParam.shareName"
              clearable
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="认证用户ID" prop="shareGbCode">
            <el-input
              v-model="deviceParam.shareGbCode"
              clearable
              placeholder="请输入认证用户ID"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div style="float: center">
              <el-button type="primary" @click="onSubmit" v-if="!isView"
                >保存</el-button
              >
              <el-button @click="$emit('close')">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  deviceName: "device",
  props: {
    dialogTitle: {
      type: String,
      default: "编辑设备",
    },
    // 添加/修改/详情
    handleType: {
      type: String,
      default: "add",
    },
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      listChangeCallback: null,
      showDialog: true,
      isLoging: false,
      deviceParam: {
        shareGbCode: "",
        shareName: "",
      },
      rules: {
        shareName: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        shareGbCode: [
          {
            required: true,
            message: "请输入认证用户ID",
          },
          {
            // 只能输入20位数字
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入认证用户ID"));
              } else if (!/^\d{1,20}$/.test(value) || value.length != 20) {
                callback(new Error("只能输入20位数字"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  computed: {
    isView() {
      return this.handleType === "view";
    },
  },
  mounted() {
    if (Object.keys(this.row).length > 0) {
      this.deviceParam = { ...this.row };
    }
  },
  methods: {
    onSubmit: function () {
      console.log("onSubmit");
      var that = this;
      this.$refs.addDeivce.validate((valid) => {
        if (valid) {
          this.isLoging = true;
          const params = {
            devices: [
              {
                ...this.row,
                ...that.deviceParam,
              },
            ],
          };
          that
            .$axios({
              method: "post",
              url: "/api/share/devices/set",
              data: params,
              params: {
                token: this.$cookies.get("session").token,
              },
            })
            .then((res) => {
              if (res.data.code == 0) {
                that.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success",
                });
                this.$emit("success");
                this.$emit("close");
              } else {
                that.$message.error(that.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(() => {
              this.isLoging = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style>
.el-form-item__label {
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/HandleShareDeviceDlg.vue